import React from 'react'
import Loading from "../../components/common/Loading";
import dynamic from "next/dynamic";
import Head from "next/head";
import SchemaTags from "@/components/common/SchemaTags";

const MobileDigitalPayment = dynamic(() => import('../../components/digitalPayment/MobileDigitalPayment'), {
  loading: () => <Loading />,
})
const DesktopDigitalPayment = dynamic(() => import('../../components/digitalPayment/DesktopDigitalPayment'), {
  loading: () => <Loading />,
})
const digitalPaymentSoftware = ({ mobileView }) => {
  return (
    <>
      <Head>
        <title>QB Digital Payments - Enabled With Cash, UPI & Credit Cards</title>
        <link rel="canonical" href="https://queuebuster.co/features/digital-payment-software" />
        <link rel="alternate" href="https://queuebuster.co/features/digital-payment-software" hrefLang="en-us" />
        <meta name="description" content="Seamless transactions with QB Digital Payments! Accept payments effortlessly with cash, UPI, and credit cards. Secure, fast, and convenient solutions for your business needs" />
        <meta property="og:title" content="QB Digital Payments: Accept Cash, UPI, Credit/debit Cards, Wallets and Vouchers Seamlessly!" />
        <meta property="og:description" content="Experience effortless transactions with QB Digital Payments! Accept cash, UPI, credit/debit cards, wallets, and vouchers seamlessly. Secure and convenient payment solutions for your business needs." />
        <meta property="og:image" content="https://quebuster.s3.ap-south-1.amazonaws.com/website/assets/OG+Images/payment-og%2B(1)+(1).jpg" />
        <meta property="og:url" content="https://queuebuster.co/features/digital-payment-software" />
      </Head>
      <SchemaTags page="digital-payment-software" />
      {mobileView ? <MobileDigitalPayment /> : <DesktopDigitalPayment />}
    </>
  )
}

export default digitalPaymentSoftware
